import {Box, Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	padding: 16px;
	gap: 16px;
	width: 100%;
	flex: 1;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
		margin-inline: auto;
		max-width: 916px;
	}
`;

const StyledGrid = styled(Box)`
	display: grid;
	grid-template-columns: 1fr;
	gap: 16px;
	align-items: flex-start;

	${({theme}) => theme.breakpoints.up('sm')} {
		grid-template-columns: 1fr 1fr;
		column-gap: 24px;
	}
`;

const StyledFooterContainer = styled(Box)`
	margin: auto 0px 16px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

export {StyledStack, StyledGrid, StyledFooterContainer};
